import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ReplayAnalyzerComponent } from "./replay-analyzer.component";

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [ReplayAnalyzerComponent],
  declarations: [ReplayAnalyzerComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ReplayAnalyzerComponentModule {}
